import { gql } from '@apollo/client';

const deleteInteressent = gql`
  mutation ($variables: InteresentById!) {
    deleteInteresent(input: $variables)
  }
`;

export default deleteInteressent;
